module.exports = __webpack_public_path__ + "img/schoolBgc.6634e1d3.png";